import React from "react";
import {
  Box,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";

interface MyTimeSelectProps {
  id: string;
  label: string;
  show: boolean;
  value: string | number;
  setValue: (value: string | number) => void;
  values: { value: string | number; label: string }[];
}

export const MyTimeSelect: React.FC<MyTimeSelectProps> = ({
  id,
  label,
  show,
  value,
  setValue,
  values,
}) => {
  const handleChange = (event: SelectChangeEvent<string | number>) => {
    setValue(event.target.value as string | number);
  };

  return (
    <Collapse in={show}>
      <Box
        style={{
          padding: "32px 0px 0px 0px",
        }}
      >
        <FormControl fullWidth variant="outlined">
          <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel>
          <Select id={id} label={label} value={value} onChange={handleChange}>
            {values?.map((item, index) => {
              return (
                <MenuItem key={`my-time-select-${index}`} value={item.value}>
                  {item.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
    </Collapse>
  );
};

export default MyTimeSelect;
